export default {
  name: 'auth--permission',
  apiService: 'auth',
  apiPath: '/permission',
};